module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.5d31421a.mp3";